import React from 'react';
import {Form as FormAnt, message} from 'antd';

const validateMessages = {
    required: '${label} é obrigatório',
    string: {
        min: '${label} deve ter no mínimo ${min} caracteres',
        max: '${label} deve ter no máximo ${max} caracteres',
    },
    types: {
        email: '${label} não é um e-mail válido',
        number: '${label} não é um número válido',
    },
};

function Form({children,  ...props}) {

    return (
        <FormAnt load scrollToFirstError onFinishFailed={() => message.error("Alguns campos são obrigatorios")} preserve layout="vertical" validateMessages={validateMessages} {...props}>
            {children}
        </FormAnt>
    );
}

Form.Item = FormAnt.Item;
Form.List = FormAnt.List;
Form.useForm = FormAnt.useForm
Form.useWatch = FormAnt.useWatch
Form.useFormInstance = FormAnt.useFormInstance

export default Form;

